import { Link } from "react-router-dom";
// import logo from '../assets/img/logos/logo2.png';

export default function NavLogin () {
    return (
        <>
        <header id="header" className="d-flex align-items-center">
            <div className="container d-flex align-items-center justify-content-between">
            <h1 className="logo"><Link to="/" style={{fontSize: '24px'}}>주식회사 공간지적측량</Link></h1>
            </div>
        </header>
        </>
    );
}